// import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import _ from 'lodash';

import ProductInfoDialog from 'shared/components/Product/ProductInfoDialog.vue';

import ProductItemBase from './ProductItemBase';

@Component({
  name: 'AppProductItem',
  props: {
    allowedFastOrder: Boolean,
    selectedProducts: Array,
  },
})
export default class ProductItem extends mixins(ProductItemBase) {
  // props
  allowedFastOrder: boolean;
  selectedProducts: UUID[];

  // computed
  get coupon(): Coupon | null {
    if (this.product.coupons) {
      return this.product.coupons[0];
    }

    return null;
  }

  get price(): string {
    if (this.coupon) {
      const basePriceComponent = _.find(
        this.product.price_components,
        {
          price_component_type: {
            name: 'Base',
          },
        }
      );

      return basePriceComponent.price;
    }

    return this.product.product_price;
  }

  get product(): Product {
    if (this.checkedStatus === 2) {
      return this.item.fast;
    }

    return this.item.default;
  }

  get tooltipContent(): string {
    const isRiskProduct = _.startsWith(this.item.default.product_name, 'RiskAssessment');

    if (this.checkedStatus === 2) {
      if (isRiskProduct) {
        return 'Отчёт формирутся в течение 40 - 60 минут.';
      }

      return 'Выписка формируется в течение 30 - 50 минут.';
    }

    if (isRiskProduct) {
      return 'Отчет формируется в течение дня, но иногда нужно подождать до пяти рабочих дней.';
    }

    return 'Выписка формируется в течение дня, но иногда нужно подождать до пяти рабочих дней.';
  }

  // methods
  openInfoDialog() {
    this.$dialog.open({
      component: ProductInfoDialog,
      props: {
        product: this.checkedStatus === 2 ? this.item.fast : this.item.default,
      },
    });
  }

  toggleSelect(isFastProduct: boolean) {
    const selected: UUID[] = this.selectedProducts.slice();

    const defaultProductIndex = selected.indexOf(this.item.default.product_id);
    if (defaultProductIndex >= 0) {
      selected.splice(defaultProductIndex, 1);
    }

    const fastProductIndex = selected.indexOf(this.item.fast.product_id);
    if (fastProductIndex >= 0) {
      selected.splice(fastProductIndex, 1);
    }

    if (isFastProduct) {
      if (this.checkedStatus === 2) {
        selected.push(this.item.default.product_id);
      } else {
        selected.push(this.item.fast.product_id);
      }
    } else {
      if (this.checkedStatus < 1) {
        selected.push(this.item.default.product_id);
      }
    }

    this.$emit('change', selected);
  }
}
